import store from '../store';
import moment from 'moment';

export default
{
    formatdate: function(date)
    {
      try {
        var localTime = moment.utc(date).local().format('ddd-MMM/DD/YY');

        return localTime;
      }
      catch (e)
      {
        console.log('Error in common.js format time', e, time)
        return date;
      }
    }
};